import {CircularProgress, Stack, StackProps, Typography} from '@mui/material';

type LoadingStateProps = StackProps & {
    message?: string;
};

export function LoadingState({message = 'Gathering information...', sx, ...props}: LoadingStateProps) {
    return (
        <Stack
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                ...sx,
            }}
            {...props}
        >
            <CircularProgress color="primary" />
            {message && (
                <Typography variant="body2" component="span" sx={{mt: 2}}>
                    {message}
                </Typography>
            )}
        </Stack>
    );
}
